import { css } from 'styled-components';

export const base = css`
  display: grid;
`;
